import { client } from '@lib/api'
import { TonWalletUtils } from '@lib/secrets'

export type UnsignedTransactionResponse = {
  serializedTransaction: string
  seqNo: number
}

export async function requestUnsignedMigrationTransaction() {
  try {
    return await client.doPost<UnsignedTransactionResponse>('/wallet/migrations/create-unsigned-js', {})
  } catch (error) {
    throw error
  }
}

export async function sendSignedMigrationTransaction(trx: string) {
  try {
    return await client.doPost<void>('/wallet/migrations/return-js-mint-sc', {
      signedTransactionBOC: trx
    })
  } catch (error) {
    throw error
  }
}

export async function migrate() {
  try {
    const { serializedTransaction, seqNo } = await requestUnsignedMigrationTransaction()
    const signedTrx = await TonWalletUtils.signMessage(serializedTransaction, seqNo)
    await sendSignedMigrationTransaction(signedTrx)
  } catch (error) {
    throw error
  }
}
